module.exports = __webpack_public_path__ + "img/icon_historial.10dd7fd2.svg";